import { DiscardUploadConfirmationModal, PersistUploadConfirmationModal } from '../../UploadConfirmationModals';
import React, { useContext } from 'react';
import { MultiPortfolioReviewContext } from '../common/MultiPortfolioReviewContext';
import { ConfirmationModalType } from '../common/MultiPortfolioReviewComponents.ConfirmationModal';

export const ConfirmationModal = () => {
  const {
    data: { confirmationModalType },
    actions: { savePortfolios, goBackToUploadStep, closeConfirmationModal },
  } = useContext(MultiPortfolioReviewContext);

  return (
    <>
      {confirmationModalType === ConfirmationModalType.Upload && (
        <PersistUploadConfirmationModal
          onConfirm={() => {
            closeConfirmationModal();
            savePortfolios();
          }}
          onCancel={closeConfirmationModal}
          isHistorical={false}
        />
      )}
      {confirmationModalType === ConfirmationModalType.Discard && (
        <DiscardUploadConfirmationModal
          closeEntireUploader={false}
          onConfirm={() => {
            closeConfirmationModal();
            goBackToUploadStep();
          }}
          onCancel={closeConfirmationModal}
        />
      )}
    </>
  );
};
